module.exports = __webpack_public_path__ + "img/Rotation1.8c86b8b7.jpg";